module.exports = __webpack_public_path__ + "media/img/flags/de-11206ee4e038ad6ebaf1f04a64a5345a.svg";